import { render, staticRenderFns } from "./HelperProvider.vue?vue&type=template&id=2548514c&"
import script from "./HelperProvider.vue?vue&type=script&lang=js&"
export * from "./HelperProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports